/* eslint-disable react/style-prop-object */
import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import ViewCompany from "./ViewCompany/ViewCompany";
import { useGetSpecificCompanyQuery } from "../../../Redux/service/Companies/Company";
import { ConfigProvider, Tag } from "antd";
import Button from "../../Helpers/Button/Button";
import { useContext, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";
import usePermission from "../../../hooks/usePermission";

export function CompanyPopup({ companyId, onClose }) {
	const { data, isFetching, refetch } = useGetSpecificCompanyQuery(companyId, {
		skip: !companyId,
		refetchOnMountOrArgChange: true,
	});
	const { handleShow } = useContext(popupcontext);
	const [selected, setSelected] = useState("General");
	const [manageProjects, setManageProjects] = useState(false);

	const { edit: canEdit } = usePermission("SNAG");
	const company = data?.data || "";

	const statusColors = {
		ACTIVE: `green`,
		INACTIVE: `red`,
	};

	const onEdit = () => {
		onClose();
		handleShow("editForm", "company", companyId);
	};

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: "#0f6936",
					activeBg: "#0f6936",
					activeBorderColor: "#2e9245",
				},
			}}
		>
			<Popup show={!!companyId} size={"xl"}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={
								<div>
									{company.name || "Loading..."}{" "}
									{!isFetching && company.status && (
										<Tag
											color={
												statusColors[company.status] || statusColors.INACTIVE
											}
											className="text-capitalize"
										>
											{trans(company.status)}
										</Tag>
									)}
								</div>
							}
							subtitle={`${company.code || ""}`}
						/>
					</Modal.Title>
					<Close style="close-32 close" close={onClose} img="Close" />
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable fixed-popup-height">
					{isFetching ? (
						<div className="loader-container">
							<Loader />
						</div>
					) : (
						<ViewCompany
							data={company}
							selected={selected}
							setSelected={setSelected}
							manageProjects={manageProjects}
							setManageProject={setManageProjects}
							refetch={refetch}
						/>
					)}
				</Modal.Body>
				<Modal.Footer>
					<div className="popups-footer gap-8">
						{canEdit && selected === "General" && (
							<Button
								type="primary"
								text={trans("Edit Company")}
								htmlType="submit"
								onClick={() => onEdit()}
							/>
						)}
						{canEdit && selected === "Projects" && (
							<Button
								type="primary"
								text={
									!manageProjects
										? trans("Manage Projects")
										: trans("Cancel Manage")
								}
								htmlType="button"
								onClick={() => setManageProjects(!manageProjects)}
							/>
						)}
					</div>
				</Modal.Footer>
			</Popup>
		</ConfigProvider>
	);
}
